<div class="upld-wrap dv-add-addrss">
	<div class="upld-ttl ">
		<button class="closedialog" (click)="closeDialog()">
			<i class="material-icons">close</i>
		</button>
		<h4 *ngIf="!isUpdate"> New Address</h4>
		<h4 *ngIf="isUpdate">Update Address</h4>
	</div>
	<form [formGroup]="addNewAddressForm"
		(submit)="isUpdate ? fn_UpdateAddress(addNewAddressForm) : fn_AddNewAddress(addNewAddressForm)">
		<div class="adrs-blk">
			<!-- Name -->
			<mat-form-field>
				<mat-label>First Name</mat-label>
				<input matInput required formControlName="Name">
				<mat-error *ngIf="f.Name.touched && f.Name.invalid && f.Name.pristine">
					<strong>Required</strong>
				</mat-error>
				<mat-error *ngIf="!f.Name.valid && (!f.Name.hasError('pattern') && f.Name.touched && f.Name.dirty)">
					<strong>Required</strong>
				</mat-error>
				<mat-error *ngIf="!f.Name.valid && (f.Name.hasError('pattern') && f.Name.dirty)">
					Should contain only letters
				</mat-error>
			</mat-form-field>
			<mat-form-field>
				<mat-label>Last Name</mat-label>
				<input matInput required formControlName="LastName">
				<mat-error *ngIf="f.LastName.touched && f.LastName.invalid && f.LastName.pristine">
					<strong>Required</strong>
				</mat-error>
				<mat-error
					*ngIf="!f.LastName.valid && (!f.LastName.hasError('pattern') && f.LastName.touched && f.LastName.dirty)">
					<strong>Required</strong>
				</mat-error>
				<mat-error *ngIf="!f.LastName.valid && (f.LastName.hasError('pattern') && f.LastName.dirty)">
					Should contain only letters
				</mat-error>
			</mat-form-field>
			<mat-form-field>
				<mat-label>Phone</mat-label>
				<input matInput type="text" maxlength="10" formControlName="PhoneNumber" required>

				<mat-error *ngIf="f.PhoneNumber.hasError('required') && f.PhoneNumber.touched">
					 <strong>required</strong>
				</mat-error>

				<mat-error *ngIf="f.PhoneNumber.hasError('pattern') && f.PhoneNumber.touched">
					Only digits allowed
				</mat-error>

				<mat-error
					*ngIf="(f.PhoneNumber.hasError('minlength') || f.PhoneNumber.hasError('maxlength')) && f.PhoneNumber.touched">
					Phone number must be exactly 10 digits
				</mat-error>
			</mat-form-field>
			<mat-form-field>
				<mat-label>Email</mat-label>
				<input matInput required formControlName="Email">
				<mat-error *ngIf="f.Email.hasError('required') && f.Email.touched">
					<strong>Email is required</strong>
				</mat-error>

				<mat-error *ngIf="f.Email.hasError('email') && f.Email.touched">
					Invalid email address
				</mat-error>
			</mat-form-field>

			<!-- Country -->
			<mat-form-field>
				<mat-select placeholder="Country" required formControlName="CountryId"
					(selectionChange)="getStatesByCountry($event.value)">
					<mat-option *ngFor="let country of countries" [value]="country.Value">
						{{country.Text}}
					</mat-option>
				</mat-select>
				<mat-error
					*ngIf="!f.CountryId.valid && f.CountryId.touched && (f.CountryId.pristine || f.CountryId.dirty)">
					<strong>Required</strong>
				</mat-error>
			</mat-form-field>
			<!-- State -->
			<mat-form-field>
				<mat-select placeholder="State" required formControlName="StateId">
					<mat-option *ngFor="let state of states" [value]="state.Value">
						{{state.Text}}
					</mat-option>
				</mat-select>
				<mat-error *ngIf="!f.StateId.valid && f.StateId.touched && (f.StateId.pristine || f.StateId.dirty)">
					<strong>Required</strong>
				</mat-error>
			</mat-form-field>
			<!-- City -->
			<mat-form-field>
				<mat-label>City</mat-label>
				<input matInput required formControlName="City">
				<mat-error *ngIf="f.City.touched && f.City.invalid && f.City.pristine">
					<strong>Required</strong>
				</mat-error>
				<mat-error *ngIf="!f.City.valid && (!f.City.hasError('pattern') && f.City.touched && f.City.dirty)">
					<strong>Required</strong>
				</mat-error>
				<mat-error *ngIf="!f.City.valid && (f.City.hasError('pattern') && f.City.dirty)">
					Should contain only letters
				</mat-error>
			</mat-form-field>
			<!-- Pin Code -->
			<mat-form-field>
				<mat-label>Zipcode</mat-label>
				<input matInput type="text" formControlName="ZipCode">
				<mat-error *ngIf="!f.ZipCode.valid && f.ZipCode.touched">
					<mat-error *ngIf="f.ZipCode.hasError('pattern') 
					&& (f.ZipCode.pristine || f.ZipCode.dirty)">
						Should contain only numbers
					</mat-error>
					<mat-error *ngIf="(f.ZipCode.hasError('minlength') || f.ZipCode.hasError('maxlength'))
					&& (f.ZipCode.pristine || f.ZipCode.dirty)">
						Length should be 5
					</mat-error>
					<mat-error *ngIf="(!f.ZipCode.hasError('pattern') && !f.ZipCode.hasError('minlength') && !f.ZipCode.hasError('maxlength'))
				   && (f.ZipCode.pristine || f.ZipCode.dirty)">
						<strong>Required</strong>
					</mat-error>
				</mat-error>
			</mat-form-field>

			<!-- Address line -->
			<mat-form-field class="full-width-adrs">
				<mat-label>Address</mat-label>
				<textarea matInput required formControlName="AddressLine"></textarea>
				<mat-error
					*ngIf="!f.AddressLine.valid && f.AddressLine.touched && (f.AddressLine.pristine || f.AddressLine.dirty)">
					<strong>Required</strong>
				</mat-error>
			</mat-form-field>
			<div class="text-right">
				<button mat-raised-button class="mat-btn btn-success"
					[disabled]="addNewAddressForm.invalid">Submit</button>
			</div>
		</div>
	</form>
</div>